module.exports = __webpack_public_path__ + "static/img/facebook.776ed721.svg";